import React, { Component, Fragment } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";

class TiktokShop extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Col sm="12">
            <h1>
              <IntlMessages id="menu.tiktok-shop" />
            </h1>
            <div className="separator mb-5" />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col md="6" lg="5">
            <Card className="text-center">
              <CardBody className="py-5">
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 80,
                    height: 80,
                    borderRadius: 16,
                    backgroundColor: "#000000",
                    color: "#fff",
                    fontSize: 36,
                    fontWeight: 700,
                    marginBottom: 24,
                  }}
                >
                  T
                </div>
                <h3 className="mb-3">TikTok Shop</h3>
                <p className="text-muted mb-4">
                  <IntlMessages id="ecommerce.coming-soon-desc" />
                </p>
                <span className="badge badge-pill badge-warning px-3 py-2" style={{ fontSize: 13 }}>
                  <IntlMessages id="ecommerce.coming-soon" />
                </span>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default TiktokShop;
